export const UPDATE_BALANCES = 'UPDATE_BALANCES';

export const SET_AUTH_GRANT = 'SET_AUTH_GRANT';

export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
// no 'SUCCEEDED', because we will fetch grant on success

export default {};



// WEBPACK FOOTER //
// ../../src/user/actionTypes.js